module.exports = __webpack_public_path__ + "static/map-3299e5c0d9f8002e37c5a33fa615a856.png";